 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML9780226649214_02_CPY from '@/components/html/9780226649214_02_cpy'
 import HTML9780226649214_01_TIT from '@/components/html/9780226649214_01_tit'
 import HTML9780226649214_03_TOC from '@/components/html/9780226649214_03_toc'
 import HTML9780226649214_04_CH1 from '@/components/html/9780226649214_04_ch1'
 import HTML9780226649214_05_PT1 from '@/components/html/9780226649214_05_pt1'
 import HTML9780226649214_06_CH2 from '@/components/html/9780226649214_06_ch2'
 import HTML9780226649214_07_CH3 from '@/components/html/9780226649214_07_ch3'
 import HTML9780226649214_08_CH4 from '@/components/html/9780226649214_08_ch4'
 import HTML9780226649214_09_CH5 from '@/components/html/9780226649214_09_ch5'
 import HTML9780226649214_10_CH6 from '@/components/html/9780226649214_10_ch6'
 import HTML9780226649214_11_CH7 from '@/components/html/9780226649214_11_ch7'
 import HTML9780226649214_12_PT2 from '@/components/html/9780226649214_12_pt2'
 import HTML9780226649214_13_CH8 from '@/components/html/9780226649214_13_ch8'
 import HTML9780226649214_14_CH9 from '@/components/html/9780226649214_14_ch9'
 import HTML9780226649214_15_CH10 from '@/components/html/9780226649214_15_ch10'
 import HTML9780226649214_16_CH11 from '@/components/html/9780226649214_16_ch11'
 import HTML9780226649214_17_CH12 from '@/components/html/9780226649214_17_ch12'
 import HTML9780226649214_18_CH13 from '@/components/html/9780226649214_18_ch13'
 import HTML9780226649214_19_CH14 from '@/components/html/9780226649214_19_ch14'
 import HTML9780226649214_20_CH15 from '@/components/html/9780226649214_20_ch15'
 import HTML9780226649214_21_CH16 from '@/components/html/9780226649214_21_ch16'
 import HTML9780226649214_22_CON from '@/components/html/9780226649214_22_con'
 import HTML9780226649214_23_TOXIND from '@/components/html/9780226649214_23_toxind'
 import HTML9780226649214_24_SUBIND from '@/components/html/9780226649214_24_subind'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/9780226649214_03_toc",
 			"name" : "html/9780226649214_03_toc",
 			"component" : HTML9780226649214_03_TOC
 		},
 		{
 			"path" : "/html/9780226649214_04_ch1",
 			"name" : "html/9780226649214_04_ch1",
 			"component" : HTML9780226649214_04_CH1
 		},
 		{
 			"path" : "/html/9780226649214_05_pt1",
 			"name" : "html/9780226649214_05_pt1",
 			"component" : HTML9780226649214_05_PT1
 		},
 		{
 			"path" : "/html/9780226649214_06_ch2",
 			"name" : "html/9780226649214_06_ch2",
 			"component" : HTML9780226649214_06_CH2
 		},
 		{
 			"path" : "/html/9780226649214_07_ch3",
 			"name" : "html/9780226649214_07_ch3",
 			"component" : HTML9780226649214_07_CH3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js